import { render, staticRenderFns } from "./SupplierSideMenu.vue?vue&type=template&id=78cbb943&"
import script from "./SupplierSideMenu.vue?vue&type=script&lang=js&"
export * from "./SupplierSideMenu.vue?vue&type=script&lang=js&"
import style0 from "./SupplierSideMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports